import { FC, ReactNode } from 'react';
import clsx from 'clsx';
import styles from './PrimaryButton.module.scss';

type Props = {
    onClick?: () => void;
    icon?: JSX.Element;
    type: 'submit' | 'reset' | 'button';
    isLoading?: boolean;
    className?: string;
    disabled?: boolean;
    children?: ReactNode;
};

const PrimaryButton: FC<Props> = ({
    onClick,
    type = 'button',
    icon,
    children,
    isLoading,
    className,
    disabled = false,
}) => {
    return (
        <button
            className={clsx(styles.Button, styles.PrimaryButton, className)}
            onClick={onClick}
            type={type}
            disabled={disabled}
        >
            {isLoading && <div className={styles.Loader} />}
            <span className={styles.Text}>{children}</span>
            {icon}
        </button>
    );
};

export default PrimaryButton;
